// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__2o20-","BigWrapper":"App__BigWrapper__3RS4D","InstructionWrapper":"App__InstructionWrapper__2hv-e","Instruction":"App__Instruction__jshQi"};


//////////////////
// WEBPACK FOOTER
// ./src/CSS/App.css
// module id = 83
// module chunks = 0